import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { RegistrarPage } from '../registrar/registrar';
import { Http } from '@angular/http';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  correo;
  pw;
  constructor(public navCtrl: NavController,
     public navParams: NavParams,
     public alertCtrl: AlertController,
     public toastCtrl: ToastController,public http: Http) {
  }
  showPrompt() {
    let prompt = this.alertCtrl.create({
      title: 'Recuperar password',
      message: "Entra tu email para recuperar password",
      inputs: [
        {
          name: 'email',
          placeholder: 'Email'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {

          }
        },
        {
          text: 'Enviar',
          handler: data => {
            let toast = this.toastCtrl.create({
              message: 'Password enviado a tu correo',
              duration: 3000
            });
            toast.present();
          }
        }
      ]
    });
    prompt.present();
  }
  reg(){
    this.navCtrl.push(RegistrarPage);
  }
  entrar(){
    let params = "correo="+this.correo+"&pw="+this.pw;
    this.http.get('https://ebenlovequickpc.com/API/login.php?cl=select&'+params).subscribe((data)=>{

      if(data.status==200){
        localStorage.setItem("TOKEN",data.json()[0]);
        localStorage.setItem("user",JSON.stringify(data.json()[1]));
       window.location.href = "./";
      }
  });
  }
  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts